// Order Reverse Logistic API
import {
    RequestConfigFunction,
} from 'app/types/request.types'

type ReverseLogisticRequests = {
    getOptions: RequestConfigFunction<{
        params?: Record<string, any>,
    }>,
    populateOrderStep: RequestConfigFunction<{
        params?: Record<string, any>,
    }>,
}

const reverseLogisticRequests: ReverseLogisticRequests = {
    getOptions: ({
        params = {},
    } = {}) => {
        return {
            url: 'order/internal-transport/reverse-logistic/options',
            method: 'POST',
            ...params,
        }
    },
    populateOrderStep: ({
        params = {},
    } = {}) => {
        return {
            url: 'order/internal-transport/reverse-logistic/population/orderstep',
            method: 'POST',
            data: params,
        }
    },
}

export default reverseLogisticRequests
